import I18n from "i18n-js";
import Ddl from "../../../models/common/Ddl";
import { TrafficArea } from "../../../models/tariff/trafficAreas/TrafficArea";
import { TrafficAreaEnum } from "../../../models/tariff/trafficAreas/TrafficAreaEnum";

const TrafficAreaUtility = {
  getName(trafficArea: TrafficArea | undefined) {
    if (!trafficArea) return "";

    if (trafficArea.id === TrafficAreaEnum.All) return I18n.t("tickets.trafficAreaAll");

    return trafficArea.name;
  },

  getNames(
    trafficAreasIds: number[],
    trafficAreas: TrafficArea[] | undefined,
  ): string {
    if (!trafficAreas || trafficAreasIds.length === 0) return "";

    return trafficAreasIds
      .map((areaId) =>
        TrafficAreaUtility.getName(
          trafficAreas.find((trafficArea) => trafficArea.id === areaId),
        ),
      )
      .filter(Boolean)
      .join(", ");
  },

  getAsDdl(trafficAreas: TrafficArea[] | undefined): Ddl[] {
    if (!trafficAreas) return [];

    const ddls = trafficAreas
      ?.sort((a, b) => a.position - b.position)
      .map(
        (trafficArea) =>
          ({
            id: trafficArea.id,
            value: TrafficAreaUtility.getName(trafficArea),
          }) as Ddl,
      );

    return ddls;
  },
};

export default TrafficAreaUtility;
